import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import Section from '../section';
import APIKeys from '../api-keys/api-keys';

function APIKeysDashboard() {
  return (
    <div className="content-container">
        <Grid2 spacing={2} container alignItems="stretch">
            <Grid2 xs={12} md={4} display="flex">
            <Section title="My API Key">
                <APIKeys />
            </Section>
            </Grid2>
        </Grid2>
    </div>
  );
}

export default APIKeysDashboard;
